import styled from 'styled-components'
import { Color } from 'root-constants'

export const StyledSecurityInfo = {
  Wrapper: styled.div`
    position: relative;
    margin: 46px 0 24px;
    padding: 50px 20px 20px;
    background: #1f2435;
    box-shadow: 0 4px 12px -2px rgba(59, 59, 62, 0.16);
    border-radius: 20px;
  `,
  Title: styled.h2`
    padding-bottom: 10px;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
  `,
  Text: styled.p`
    padding-bottom: 20px;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: ${Color.LIGHT};

    a {
      font-weight: 700;
      color: #0091ff;
    }
  `,
  SecureBadge: styled.div`
    background: ${Color.WHITE};
    box-shadow: 0 4px 12px -2px rgba(59, 59, 62, 0.16);
    padding: 4px 43px;
    border-radius: 14px;
    position: absolute;
    top: -30px;
    left: calc(50% - 78px);
    max-width: 156px;
  `,
  Image: styled.img``,
}
